import React, { useState } from "react";
import { auth, db, googleProvider } from "../firebase";
import { signInWithPopup } from "firebase/auth";
import { ref, get } from "firebase/database";
import { saveSessionRole } from "../roles";
import { useNavigate } from "react-router-dom";

export default function AdminLogin() {
  const [err, setErr] = useState("");
  const nav = useNavigate();

  async function login() {
    setErr("");
    try {
      const cred = await signInWithPopup(auth, googleProvider);
      const email = (cred.user.email || "").toLowerCase();
      const key = btoa(email);
      const ok = await get(ref(db, `adminsByEmail/${key}`));
      if (!ok.exists() || ok.val() !== true) {
        setErr("You are not on the admin allowlist.");
        return;
      }
      saveSessionRole("admin", { email, name: cred.user.displayName || "" });
      nav("/admin/admins");
    } catch (e) {
      setErr(e.message);
    }
  }

  return (
    <div className="max-w-md mx-auto bg-white rounded-2xl shadow p-6 space-y-4">
      <h1 className="text-2xl font-bold">Admin Login</h1>
      <button onClick={login} className="w-full py-3 rounded-xl border hover:bg-gray-50">
        Continue with Google
      </button>
      {err && <div className="text-red-600 text-sm">{err}</div>}
      <p className="text-xs text-gray-500">Only emails on the admin allowlist can sign in.</p>
    </div>
  );
}
